/**
 * «+ Agregar otra métrica» / «+ Agregar otra dimensión» al final del selector de un gráfico (C-05 del
 * recorrido con Pablo, 14/10). El selector lista sólo los campos de «Métricas y dimensiones» (la paleta
 * de la hoja) y no tenía salida: con 11 métricas fijas el usuario concluía «tengo re pocas opciones».
 * La opción abre ese mismo modal y, al aplicar, el gráfico vuelve con el campo nuevo ya elegido.
 *
 * Lógica pura: qué le pasa al panel con lo que se sumó a la paleta.
 */
import {metricsLimitFor} from './chartFields';
import {dimensionNames, FIELD_KINDS, metricNames} from './informeModel';

// El valor de la opción del `<select>`: no puede ser el nombre de un campo del catálogo.
export const ADD_FIELD_OPTION = '__inf_add_field__';

/**
 * El cambio del panel después de aplicar la paleta desde su selector, o `null` si no cambia nada.
 * - Métrica, en un gráfico de una sola (destacada, torta): pasa a ser la nueva.
 * - Métrica, en uno de varias (barras, evolución): se SUMA a las que tenía, hasta su tope
 *   (`metricsLimitFor`), en el orden de la paleta como hace el selector. Lleno, no cambia: el selector
 *   no ofrece agregar en ese caso.
 * - Dimensión (barras, torta): pasa a ser la nueva.
 * Las que tenía y ya no están en la paleta las poda el reducer (`FIELDS_APPLY`); acá se calcula sobre
 * lo que queda, para no contar en el tope una métrica que se quitó en el mismo modal.
 */
export function panelPatchAfterAdding(panel, previousFields, nextFields, kind) {
    if (!panel) return null;
    if (kind === FIELD_KINDS.DIMENSION) {
        const before = dimensionNames(previousFields);
        const added = dimensionNames(nextFields).filter((name) => !before.includes(name));
        return added.length ? {dimension: added[0]} : null;
    }
    const before = metricNames(previousFields);
    const palette = metricNames(nextFields);
    const added = palette.filter((name) => !before.includes(name));
    if (!added.length) return null;
    const limit = metricsLimitFor(panel.type);
    if (limit <= 1) return {metrics: [added[0]]};
    const kept = (panel.metrics || []).filter((name) => palette.includes(name));
    const room = limit - kept.length;
    if (room <= 0) return null;
    const chosen = new Set([...kept, ...added.slice(0, room)]);
    return {metrics: palette.filter((name) => chosen.has(name))};
}
